import React from "react";
import { List, Typography } from "antd";
import deleteIcon from "../../assets/images/greyIcons/greyDelete.png";
import editIcon from "../../assets/images/greyIcons/greyEdit.png";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const ContactList = ({ handleEdit, handleDeleteClick, data }) => {
  if (!data || data.length === 0) {
    return null;
  }


  const formatPhoneNumber = (number) => {
    if (!number) return "";
    const cleaned = number.replace(/[^+\d]/g, "");
  
    try {
      const parsed = parsePhoneNumberFromString(cleaned);
      if (!parsed) return number;
      if (cleaned.startsWith("+1")) {
        const national = String(parsed.nationalNumber);
        if (national.length === 10) {
          const areaCode = national.slice(0, 3);
          const centralOffice = national.slice(3, 6);
          const lineNumber = national.slice(6);
          return `+1(${areaCode})-${centralOffice}-${lineNumber}`;
        }
      }

      return parsed.formatInternational();
    } catch {
      return number;
    }
  };
  
  return (
    <List
      dataSource={data}
      renderItem={(contact,index) => (
        <List.Item
          actions={[
            <img
              src={editIcon}
              alt="Edit"
              onClick={() => handleEdit(contact,index)}
              style={{ cursor: "pointer" }}
            />,
            <img
              src={deleteIcon}
              alt="Delete"
              onClick={() => handleDeleteClick(contact,index)}
              style={{ cursor: "pointer" }}
            />,
          ]}
          style={{ padding: "12px 0", borderBottom: "1px solid #EAEAEA" }}
          className="custom-contact-list"
        >
          <List.Item.Meta
            title={
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "12px",
                  color: "#000000",
                  marginBottom: "0px",
                  lineHeight: "16px",
                }}
              >
                {contact.name}, {contact.title}{" "}
                {contact.is_primary_contact ? "(primary)" : ""}
              </span>
            }
            description={
              <>
                <a
                  href={`mailto:${contact.email}`}
                  style={{
                    color: "#000000",
                    fontSize: "12px",
                    fontWeight: "400",
                    textDecoration: "underline",
                    lineheight: "20px",
                  }}
                >
                  {contact.email}
                </a>
                ,{" "}
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  {formatPhoneNumber(contact.phone_number)}
                </span>
              </>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default ContactList;
